import { Card } from '@hg/stylizator/components'
import { Text } from '@hg/stylizator/typography'
import { StringReactElement } from '@hg/stylizator/utils'
import * as React from 'react'
import styled from 'styled-components'

import SignupButton from 'app/components/SignupCampaign/buttons/SignupButton'
import CloseIcon from 'app/components/SignupCampaign/icons/CloseIcon'

interface IProps {
  onClose: () => void
  heading: React.ReactElement
  content: React.ReactElement
  buttonText: string
  buttonUrl: string
}

const SignupCard: React.FC<IProps> = (props) => (
  <CardView>
    <Text type="heading_xsmall" spacingType="smallest" align="center" customSpacing={[0, 0, 0, 0]}>
      <h5>
        <StringReactElement data={props.heading} />
      </h5>
    </Text>
    <ContentWrapper>
      <Text type="compact_body" align="center" customSpacing={[8, 8, 8, 8]} color="#4e7294">
        <small>
          <StringReactElement data={props.content} />
        </small>
      </Text>
    </ContentWrapper>
    <SignupButtonWrapper>
      <SignupButton text={props.buttonText} url={props.buttonUrl}>
        {props.buttonText}
      </SignupButton>
    </SignupButtonWrapper>
    <ExitIconView>
      <CloseIcon className="target-signup-card-close-button" onClick={props.onClose} size={15} />
    </ExitIconView>
  </CardView>
)

const CardView = styled(Card)`
  margin: 10px 43px;
  margin-bottom: 25px;
  position: fixed;
  bottom: 0px;
  left: 0px;
  z-index: 998;
  width: 390px !important;
`

const ExitIconView = styled.div`
  position: absolute;
  right: 15px;
  top: 15px;
  height: 0.5em;
`

const SignupButtonWrapper = styled.div`
  text-align: center;
`

const ContentWrapper = styled.div`
  padding: 10px;
`

export default SignupCard
